'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./dist/server-renderer.cjs.prod.js')
} else {
  module.exports = require('./dist/server-renderer.cjs.js')
}
